import React from 'react';
import { useNavigate } from 'react-router-dom';
import { vccStudioVendor, vccStudioServices } from '../data/a2zRentalCatalog';
import './EquipmentRentalsPage.css';
import './VccStudioPage.css';

export default function VccStudioPage() {
  const navigate = useNavigate();
  const studio = {
    name: vccStudioVendor.name,
    city: 'Hyderabad',
    region: 'Telangana',
    summary:
      'Animation, corporate films, post-production, podcasts, digital marketing, and full creative studio services.',
  };

  return (
    <div className="equipment-page">
      <div className="equipment-page-inner">
        <div className="equipment-back-row">
          <button type="button" className="equipment-back" onClick={() => navigate('/production-sourcing')}>
            ← All suppliers
          </button>
          <span className="equipment-back-sep" aria-hidden>
            ·
          </span>
          <button type="button" className="equipment-back" onClick={() => navigate('/')}>
            Home
          </button>
        </div>

        <header className="equipment-vendor-card">
          <div className="equipment-vendor-header-row">
            <div className="equipment-vendor-main">
              <h1>{studio.name}</h1>
              <p className="equipment-vendor-meta">
                {[studio.city, studio.region].filter(Boolean).join(', ')}
              </p>
              <p className="equipment-vendor-meta">{studio.summary}</p>
              <p className="equipment-disclaimer">
                Rates, timelines, and deliverables are agreed directly with the studio. Contact VCC Studio for quotes and
                availability.
              </p>
            </div>
          </div>
        </header>

        <section className="equipment-section vcc-services-section">
          <h2 className="equipment-section-title">Services</h2>
          <p className="vcc-services-intro">
            VCC Studio offers end-to-end creative and production services across the following categories:
          </p>
          <ul className="vcc-services-grid">
            {vccStudioServices.map((category) => (
              <li key={category} className="vcc-service-chip">
                {category}
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
